import { API_URL_MEDIA } from "@constants/env";
import { apiMediaToDto } from "@helpers/createMedia.helper";
import useApiCall from "@hooks/Shared/useApiCall";
import { ICreateMedia } from "@interfaces/createMedia";

const useGetMedia = (uuid: string) =>
  useApiCall<ICreateMedia>({
    url: API_URL_MEDIA + uuid,
    transformResponse: (data) =>
      apiMediaToDto(JSON.parse(data as string) as ICreateMedia),
  });

export default useGetMedia;
